import linkI from './link';
import linkHoverI from './linkHover';

export const linkIcon = linkI;
export const linkHoverIcon = linkHoverI;

export default {
  linkIcon,
  linkHoverIcon,
};
